'use strict';

const Flights = require('../../apps/app.flights');
const trackingUtils = require('../../modules/utils/tracking.utils');
const {dispatch} = require('od-modules/secure_store/store');
const actions = require('od-modules/secure_store/actions');

const getFlightSelection = () => Odigeo.Utils.parseJson(Odigeo.Session.get('flightSelectionData'));

module.exports = Odigeo.Model.extend({
    defaults: {
        searchParams: null,
        requestData: null,
        adults: 1,
    },
    selectors: ['membershipSubscriptionDetails', 'products'],
    connect: true,
    trackingLabel: null,

    url() {
        const serviceUrl = Odigeo.SessionScope.isMeta ? 'addpaxmetas' : 'addpax';
        return Odigeo.Settings.getProperty('serviceUrlFormatter')(serviceUrl);
    },

    redirectToResultPage() {
        const searchParams = Flights.searchParamsStringify(Odigeo.Session.get('searchParameters'));
        Odigeo.Router.navigate('results', {params: searchParams});
    },

    refreshData() {
        if (Odigeo.AB.isGoBackNativeMessage) {
            window.onbeforeunload = null;
        }
        var request = this.get('requestData');
        if (!Odigeo._.isNull(request)) {
            this.widget.view.showLoadingMessage();
            this.clear().save(request, {
                success: Odigeo._.bind(this.requestSuccessAddPaxHandler, this),
                error: Odigeo._.bind(this.requestErrorAddPaxHandler, this),
            });
        }
    },

    requestSuccessAddPaxHandler(model, data) {
        if (data.errors !== null) {
            this.processErrorsWhenAddPaxHandler();
        } else {
            const fareFamilies = Odigeo.Utils.parseJson(Odigeo.Session.get('fareFamiliesRequest'));
            if (fareFamilies) {
                fareFamilies.request.flightSelection.data.data.searchId = data.searchId;
                fareFamilies.request.flightSelection.data.data.fareItineraryKey = data.fareItineraryKey;
                Odigeo.Session.set('fareFamiliesRequest', JSON.stringify(fareFamilies));
            }
            this.trackingForEditPax('success');
            this.widget.view.showUpdatingOk();
            const shoppingCartDTO = model.get('shoppingCartDTO');
            const bookingId = shoppingCartDTO.bookingId;
            const page = Odigeo.SessionScope.flow === 'desktop' ? 'details' : 'passengersinfo';
            Odigeo.Session.set('bookingId', bookingId);
            Odigeo.Router.navigate(page, {bookingId});
            dispatch({type: actions.SET_SHOPPING_CART, entry: shoppingCartDTO});
            if (Odigeo.AB.isGoBackNativeMessage) {
                window.onbeforeunload = null;
            }
            Odigeo.trigger(this.widget.id + ':addPaxCompleteSuccessful', bookingId);
        }
    },

    processErrorsWhenAddPaxHandler() {
        this.trackingForEditPax('error');
        Odigeo.Session.set('showAddPaxError', 'true');
        Odigeo.trigger(this.widget.id + ':addPaxCompleteError',
            Flights.searchParamsStringify(Odigeo.Session.get('searchParameters')));
    },

    requestErrorAddPaxHandler(model, xhr) {
        if (xhr.statusText !== 'abort') {
            this.processErrorsWhenAddPaxHandler();
        }
    },

    addPax(data) {
        const preAdults = this.get('adults');
        const postAdults = data.action === 'remove' ? preAdults - 1 : preAdults + 1;
        this.set('adults', postAdults);
        this.get('searchParams').numAdults = postAdults;
        Odigeo.Session.set('searchParameters', JSON.stringify(this.get('searchParams')));
        this.prepareData();
        this.trackingLabel = this.getTrackingLabel(data.action || 'add', data.actionFrom, preAdults);
        this.trackingForEditPax();
    },

    isSearchData() {
        const dataSearch = Odigeo.Utils.parseJson(Odigeo.Storage.get('search-data'));
        const searchParameters = Odigeo.Utils.parseJson(Odigeo.Session.get('searchParameters')) || {};
        this.set('searchParams', searchParameters);
        this.set('adults', searchParameters.numAdults);
        if (Odigeo._.isEmpty(this.get('searchParams')) && !Odigeo._.isEmpty(dataSearch)) {
            this.set('searchParams', dataSearch[0]);
        }
        return !Odigeo._.isEmpty(this.get('searchParams'));
    },

    getAddPaxRequest(itinerarySearchRequestData) {
        return {
            searchRequest: itinerarySearchRequestData,
            previousSearchId: getFlightSelection().data.searchId,
            flightNumbers: getFlightSelection().flightNumbers,
            fullFareItineraryKey: getFlightSelection().data.fareItineraryKey,
            priceWithoutDiscountSelected: !this.get('membershipSubscriptionDetails').primePriceSelectedInResults,
            productsToAdd: this.get('products').filter((product) => product.category === 'FARE_RULE').map((product) => product.id),
        };
    },

    prepareData() {
        const itinerarySearchRequestData = this.getItinerarySearchRequestData();
        const requestData = this.getAddPaxRequest(itinerarySearchRequestData);
        this.set('requestData', requestData);
    },

    getItinerarySearchRequestData() {
        const omitItineraryKeys = [
            'searchSegments',
        ];
        const pickSegmentKeys = [
            'iata',
            'name',
            'geoNodeId',
            'type',
        ];
        let data = this.get('searchParams');
        const type = data.type;
        data.externalSelectionRequest = this.getExternalSelectionRequest();
        data.segmentRequests = data.searchSegments;
        data = Odigeo._.omit(data, omitItineraryKeys);
        for (let i = 0; i < data.segmentRequests.length; i++) {
            data.segmentRequests[i] = Odigeo._.omit(data.segmentRequests[i], ['transportType']);
            data.segmentRequests[i].departure = Odigeo._.pick(data.segmentRequests[i].departure, pickSegmentKeys);
            data.segmentRequests[i].destination = Odigeo._.pick(data.segmentRequests[i].destination, pickSegmentKeys);
            data.segmentRequests[i].date = data.segmentRequests[i].dateStr;
        }
        data = Odigeo._.extend(data, {
            dynpackSearch: false,
            searchMainProductType: 'FLIGHT',
            type: (type === 'oneWayTrip') ? 'ONE_WAY' : (type === 'roundTrip') ? 'ROUND_TRIP' : 'MULTIPLE_DESTINATIONS',
        });

        return {'itinerarySearchRequest': data};
    },

    getExternalSelectionRequest() {
        return {
            fareItineraryKey: getFlightSelection().fareItineraryKey,
            searchId: getFlightSelection().data.searchId,
            segmentKeys: getFlightSelection().data.flightNumbers,
            flightNumbers: getFlightSelection().flightNumbers,
        };
    },

    trackingForEditPax(status) {
        const suffix = status ? `_${status}` : '';
        trackingUtils.trackEvent(
            'change_pax_functionality',
            `${this.trackingLabel}${suffix}`,
        );
    },

    getTrackingLabel(action, actionFrom, preAdults) {
        const postAdults = this.get('adults');
        return `change_pax_${actionFrom}_${action}_pre:${preAdults}-${preAdults}-0-0_post:${postAdults}-${postAdults}-0-0`;
    },
});
